<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Repair" active>
         <div class="border p-2">
              <div class="row">
                <div class="col-auto">
                  <span class="bg-primary text-white px-3 font-size-26">
                    {{ job.job_number }}</span
                  >
                </div>
                <div class="col">
                  <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                    {{ job.manufacture.description }} -
                    {{ job.device_type.description }}
                    <span v-if="job.device_model">
                      <br />
                      <strong>{{ job.device_model.code }}</strong> -
                      {{ job.imei_in ? job.imei_in : job.serial_in }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="job.assessed_by" class="border border-info p-3">
              <small class="text-info my-2 font-weight-bold">ASSESSED BY</small
              ><br />
              <i class="lni lni-user"></i> {{ job.assessed_by.name }}<br />
              <small class="text-muted">
                {{
                  moment(new Date(job.assessed_date)).format("DD MMM YY, HH:mm")
                }}
              </small>
            </div>

            <div class="border p-2">
              <div class="row">
                <div class="col-md-6">
                  <small class="text-info my-2 font-weight-bold"
                    >SYMPTOMS</small
                  >
                  <p v-if="job.symptoms_description" class="nl2br">
                    {{ job.symptoms_description }}
                  </p>

                  <div v-for="s in job.symptoms" :key="s.id">
                    {{ s.code }} - {{ s.description }}
                  </div>
                </div>
                <div class="col-md-6">
                  <small class="text-info my-2 font-weight-bold">FAULTS</small>
                  <div v-for="f in job.faults" :key="f.id">
                    {{ f.code }} - {{ f.description }}
                  </div>
                </div>
              </div>
            </div>

            <div class="border p-3 my-3">
              <table
                class="table table-sm border"
                v-if="selectedDeviceFaultActionParts.length > 0"
              >
                <tr class="bg-dark text-white font-size-11 font-weight-bold text-uppercase">
                  <td>Fault</td>
                  <td>Action</td>
                  <td>Repaired</td>
                  <td>Replaced</td>
                  <td></td>
                </tr>
                <tr v-for="l in selectedDeviceFaultActionParts" :key="l.id">
                  <td>
                    {{ l.fault.description }}
                  </td>
                  <td>
                    {{ l.action.description }}
                  </td>
                  <td>
                    <span v-if="l.repair_part_id">
                      {{
                         parts.filter((x) => x.id == l.repair_part_id)[0]
                          .code + "-" +
                        parts.filter((x) => x.id == l.repair_part_id)[0]
                          .description
                      }}
                    </span>
                  </td>
                  <td>
                    <span v-if="l.job_part">
                      {{ l.job_part.part.code +"-"+ l.job_part.part.description }}
                    </span>
                  </td>
                  <td>
                    <i
                      class="lni lni-trash text-danger"
                      @click="removeFaultActionPart(l.id)"
                    ></i>
                  </td>
                </tr>
              </table>

              <h5 class="font-weight-500">Select Fault Action Parts:</h5>

              <form-group label="Fault" :required="true">
                <b-form-select
                  v-model="selectedFault"
                  :options="job.faults"
                  value-field="id"
                  text-field="description"
                ></b-form-select>
              </form-group>

              <form-group label="Action" :required="true">
                <b-form-select
                  v-if="selectedFault"
                  v-model="selectedAction"
                  :options="
                    job.faults.filter((x) => x.id == selectedFault)[0].actions
                  "
                  value-field="id"
                  text-field="description"
                ></b-form-select>
              </form-group>


                <form-group label="Optional Part" v-if="selectedAction">
                   <b-form-radio v-model="selectedPartRepair" name="some-radios" value="Replace">Replaced Part</b-form-radio>
                   <b-form-radio v-model="selectedPartRepair" name="some-radios" value="Repair">Repair Part</b-form-radio>
                 
                </form-group>

              <form-group label="Part" v-if="selectedAction && selectedPartRepair == 'Replace'">
                <b-form-select
                  v-if="selectedAction"
                  v-model="selectedPart"
                  :options="job.job_parts.filter((x) => x.used  < x.quantity)"
                  value-field="id"
                  text-field="part.description"
                ></b-form-select>
              </form-group>


              <form-group label="Part" v-if="selectedAction && selectedPartRepair == 'Repair'">
                <b-form-select
                  v-if="selectedAction"
                  v-model="selectedPart"
                  :options="parts"
                  value-field="id"
                  text-field="description"
                ></b-form-select>
              </form-group>

              <div style="height:50px">
                <b-button
                variant="info"
                class="float-right text-white"
                @click="AddFaultActionPart"
                v-if="selectedFault && selectedAction"
                >Add</b-button>

              </div>

            
            </div>

<span v-if="!loading">
            <b-button variant="danger" @click="confirmBer" >B.E.R</b-button>
            <b-button variant="warning" @click="handleSubmit(false,true)">Re-Assess</b-button>

            <b-button variant="primary" @click="handleSubmit(false,false)" class="float-right">Repaired</b-button>
            </span>
            <span v-if="loading">
                <b-spinner label="Spinning"></b-spinner>
            </span>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";
import FormGroup from "../../../components/common/FormGroup.vue";

export default {
  components: {
    partner,
    client,
    jobMinimal,
    FormGroup,
  },



  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {
      selectedPartRepair:"Replace",
      selectedFault: null,
      selectedAction: null,
      selectedPart: null,
      selectedDeviceFaultActionParts: [],  
      parts:[],
      job: {},
      isLoad: false,
      loading: false,
      errors: null,
      submitStatus: null,
      sort: { column: "code", label: "Code Asc", order: "asc" },
      sortOptions: [
        { column: "code", label: "Code Asc", order: "asc" },
        { column: "code", label: "Code Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      sdvpid: 1,
    };
  },

  methods: {
    getParts() {},

    confirmBer() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to deem device as B.E.R.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.handleSubmit(true,false) : false))
        .catch((error) => console.log(error));
    },

    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await jobRepo.repairRepairedCreate(id);
        this.job = data.job;
        this.parts = data.parts;
        
        this.job.job_fault_actions.forEach(jfa => {
          this.sdvpid = this.sdvpid + 1;

          this.selectedDeviceFaultActionParts.push({
            id: this.sdvpid,
            fault: this.job.faults.filter((x) => x.id == jfa.fault_id)[0],
            action: this.job.faults
              .filter((x) => x.id == jfa.fault_id)[0]
              .actions.filter((x) => x.id == jfa.action_id)[0],
            job_part:
              jfa.part_id != null && jfa.part_replaced == '1'
                ? this.job.job_parts.filter((x) => x.part_id == jfa.part_id)[0]
                : null,
            repair_part_id: jfa.part_id != null && jfa.part_replaced == '0'
                ? jfa.part_id 
                : null,
          });

           if(jfa.part_id != null && jfa.part_replaced == '1'){
              this.job.job_parts = this.job.job_parts.map((x) => {
                if (x.id == jfa.part_id) {
                  x.used = x.used+1;
                }
                return x
              });
            }

        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit(ber,reAssess) {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.selectedDeviceFaultActionParts.length == 0 && ber==false && reAssess==false) {
        this.$root.$bvToast.toast("Form Errors", {
          title: "please select a fault actions",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.loading = false;
        this.submitStatus = null;
        return;
      }

   
     
        this.loading = false;
        this.submitStatus = null;

        let faultActions = []
        this.selectedDeviceFaultActionParts.forEach(x => {
          faultActions.push({
            fault_id:x.fault.id,
            action_id:x.action.id,
            repaired_part_id:x.repair_part_id?x.repair_part_id:null,
            replaced_part_id:x.job_part?x.job_part.part_id:null,
            job_part_id:x.job_part?x.job_part.id:null
          })
        })
      
        try {
          await jobRepo.repairRepairedStore(
            this.id,{fault_actions:faultActions,ber:ber?1:null,re_assess:reAssess?1:null}
          );         
          this.$emit("repairedCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      
    },

    AddFaultActionPart() {
      if (this.selectedFault == null || this.selectedAction == null) {
        this.$root.$bvToast.toast("Select Fault and Action", {
          title: "Error",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      this.sdvpid = this.sdvpid + 1;

      this.selectedDeviceFaultActionParts.push({
        id: this.sdvpid,
        fault: this.job.faults.filter((x) => x.id == this.selectedFault)[0],
        action: this.job.faults
          .filter((x) => x.id == this.selectedFault)[0]
          .actions.filter((x) => x.id == this.selectedAction)[0],
        job_part:
          this.selectedPart != null && this.selectedPartRepair == 'Replace'
            ? this.job.job_parts.filter((x) => x.id == this.selectedPart)[0]
            : null,
        repair_part_id:this.selectedPart != null && this.selectedPartRepair == 'Repair'?this.selectedPart:null
      });

      if (this.selectedPart != null) {
        if(this.selectedPartRepair=='Replace'){
          this.job.job_parts = this.job.job_parts.map((x) => {
            if (x.id == this.selectedPart) {
              x.used = x.used+1;
            }
            return x
          });
        }
       
      }

      this.$root.$bvToast.toast("Added Fault Action Part", {
        title: "Added",
        autoHideDelay: 1500,
        variant: "success",
      });

      this.selectedPart = null;
      this.selectedAction = null;
      this.selectedFault = null;
    },

    removeFaultActionPart(id) {
      let item = this.selectedDeviceFaultActionParts.filter(
        (x) => x.id == id
      )[0];

       if (item.job_part != null) {
       this.job.job_parts = this.job.job_parts.map((x) => {
          if (x.id == item.job_part.id) {
            x.used = x.used-1;
          }
          return x
        });
      }


      this.selectedDeviceFaultActionParts = this.selectedDeviceFaultActionParts.filter(
        (x) => x.id != id
      );

     
    },
  },
};
</script>

